export const getPnlChartAccountDataCalculatedUpdatedAt = (state) =>
  state.pnlChart.account.dataCalculatedupdatedAt;

export const getPnlFetchOptions = (state) => state.pnlChart.fetchOptions;

export const getPnlCalcOptions = (state) => state.pnlChart.calcOptions;

//
export const getPnlChartIsDataFetching = (state) =>
  state.pnlChart.chartData.isFetching;

export const getPnlChartDataError = (state) => state.pnlChart.chartData.error;

export const getPnlChartData = (state) => state.pnlChart.chartData.data;

export const getPnlChartDataPaging = (state) => state.pnlChart.chartData.paging;

export const getPnlChartDatafirstEntryTime = (state) =>
  state.pnlChart.chartData.firstEntryTime;

export const getPnlChartDataLastEntryTime = (state) =>
  state.pnlChart.chartData.lastEntryTime;

export const getPnlChartDataMetadata = (state) =>
  state.pnlChart.chartData.metaData;

export const getPnlChartDataGraphLevel = (state) =>
  state.pnlChart.chartData.graphLevel;

export const getPnlChartDataFilterList = (state) =>
  state.pnlChart.chartData.filterList;

export const getPnlChartDataMtmCounts = (state) =>
  state.pnlChart.chartData.data.mtmCounts || {};

export const getPnlChartDataUpdatedAt = (state) =>
  state.pnlChart.chartData.updatedAt;

export const getPnlChartQuery = (state) => state.pnlChart.chartData.query;

export const getPnlLiveUpdateAt = (state) =>
  state.pnlChart.chartData.liveUpdateAt;

//

export const getPnlChartIsUnderlyingDataFetching = (state) =>
  state.pnlChart.chartUnderlyingData.isFetching;

export const getPnlChartUnderlyingDataError = (state) =>
  state.pnlChart.chartUnderlyingData.error;

export const getPnlChartUnderlyingData = (state) =>
  state.pnlChart.chartUnderlyingData.data;

export const getPnlChartUnderlyingDataPaging = (state) =>
  state.pnlChart.chartUnderlyingData.paging;

export const getPnlChartUnderlyingDataUpdatedAt = (state) =>
  state.pnlChart.chartUnderlyingData.updatedAt;

export const getPnlChartUnderlyingDataUnderlyingName = (state) =>
  state.pnlChart.chartUnderlyingData.underlying;

//

export const getPnlChartIsClientIdListFetching = (state) =>
  state.pnlChart.clientIdList.isFetching;

export const getPnlChartClientIdListError = (state) =>
  state.pnlChart.clientIdList.error;

export const getPnlChartClientIdListData = (state) =>
  state.pnlChart.clientIdList.data || [];

export const getPnlChartClientIdListUpdatedAt = (state) =>
  state.pnlChart.clientIdList.updatedAt;

export const getPnlChartClientIdListModifiedAt = (state) =>
  state.pnlChart.clientIdList.modifiedAt;

export const getPnlChartClientIdListFilters = (state) =>
  state.pnlChart.clientIdList.filters;

export const getPnlChartClientIdListcached = (state) =>
  state.pnlChart.clientIdList.dataCached;

//

export const getPnlChartIsAlgoListFetching = (state) =>
  state.pnlChart.algoList.isFetching;

export const getPnlChartAlgoListError = (state) =>
  state.pnlChart.algoList.error;

export const getPnlChartAlgoListData = (state) =>
  state.pnlChart.algoList.data || [];

export const getPnlChartAlgoListUpdatedAt = (state) =>
  state.pnlChart.algoList.updatedAt;

export const getPnlChartAlgoListModifiedAt = (state) =>
  state.pnlChart.algoList.modifiedAt;

export const getPnlChartAlgoListFilters = (state) =>
  state.pnlChart.algoList.filters;

export const getPnlChartAlgoListcached = (state) =>
  state.pnlChart.algoList.dataCached;
